// @ts-ignore
import store from "../store";

export enum API_PAGES {
    HOME_PAGE = 'home_page',
    CHOOSE_VEHICLE = 'choose_vehicle',
    ORDER = 'order',
    CHOOSE_CUSTOM_ROUTE = 'choose_custom_route',
    LOGIN = 'login_page',
    REGISTER = 'register_page',
    FORGOT_PASSWORD = 'forgot_password_page',
    CHANGE_PASSWORD = 'change_password_page',
    TRIPS = 'trips_page',
    ROUND_TRIP_FIRST_STEP = 'round_trip_first_step',
    ROUND_TRIP_SECOND_STEP = 'round_trip_second_step',
    ROUND_TRIP_FINAL_STEP = 'round_trip_final_step',
}

export default class apiService
{
    // General
    static generalEndpoint(): string {
        return this.getApiUrl() + 'general';
    }

    // Translations
    static translationsEndpoint(): string {
        return this.getApiUrl() + 'translations';
    }

    // Translations
    static settingsEndpoint(): string {
        return this.getApiUrl() + 'settings';
    }

    // Vehicle
    static vehicleEndpoint(): string {
        return this.getApiUrl() + 'vehicle';
    }

    // Transportation
    static transportationEndpoint(): string {
        return this.getApiUrl() + 'transportation';
    }

    // Transportation addresses and transportations
    static getCitiesEndpoint(): string {
        return this.transportationEndpoint() + '/cities';
    }

    static getTransportationsEndpoint(): string {
        return this.transportationEndpoint() + '/transportations';
    }

    static getSelectedTransportationEndpoint(): string {
        return this.transportationEndpoint() + '/selected-transportation';
    }

    // Menu
    static menuEndpoint(): string {
        return this.getApiUrl() + 'menu';
    }

    // Google API Directions
    static googleApiDirectionsEndpoint(): string {
        return this.getApiUrl() + 'directions';
    }

    // GET MAIN GOOGLE API RESPONSE WITH ADDITIONAL DATA FOR RENT WITH DRIVER
    static googleApiDirectionsGetCustomDirectionEndpoint(): string {
        return this.googleApiDirectionsEndpoint() + '/getCustomDirection';
    }

    static googleApiDirectionsTextSearchEndpoint(): string {
        return this.googleApiDirectionsEndpoint() + '/textSearch';
    }

    // Get selected frequency string + translations
    static selectedFrequencyEndpoint(): string {
        return this.getApiUrl() + 'helpers/generateDateFrequencyText';
    }

    // Pages
    static pageEndpoint(): string {
        return this.getApiUrl() + 'page';
    }

    static pageHomePageEndpoint(): string {
        return this.pageEndpoint() + '/' + API_PAGES.HOME_PAGE;
    }

    static pageChooseVehiclePageEndpoint(): string {
        return this.pageEndpoint() + '/' + API_PAGES.CHOOSE_VEHICLE;
    }

    static pageOrderPageEndpoint(): string {
        return this.pageEndpoint() + '/' + API_PAGES.ORDER;
    }

    static pageOrderPageLoadAsRentServiceWithoutDriverEndpoint(): string {
        return this.pageOrderPageEndpoint() + '/loadAs/rentServiceWithoutDriver';
    }

    static pageOrderPageOrderPayseraHeartbeatEndpoint(): string {
        return this.pageOrderPageEndpoint() + '/payment/paysera/heartbeat';
    }

    static pageChooseCustomRoutePageEndpoint(): string {
        return this.pageEndpoint() + '/' + API_PAGES.CHOOSE_CUSTOM_ROUTE;
    }
    static pageLoginPageEndpoint(): string {
        return this.pageEndpoint() + '/' + API_PAGES.LOGIN;
    }
    static pageRegisterPageEndpoint(): string {
        return this.pageEndpoint() + '/' + API_PAGES.REGISTER;
    }

    static pageForgotPasswordPageEndpoint(): string {
        return this.pageEndpoint() + '/' + API_PAGES.FORGOT_PASSWORD;
    }

    static pageChangePasswordPageEndpoint(): string {
        return this.pageEndpoint() + '/' + API_PAGES.CHANGE_PASSWORD;
    }

    static pageTripsPageEndpoint(): string  {
        return this.pageEndpoint() + '/' + API_PAGES.TRIPS;
    }

    static pageRoundTripFirstStepPageEndpoint(): string  {
        return this.pageEndpoint() + '/' + API_PAGES.ROUND_TRIP_FIRST_STEP;
    }

    static pageRoundTripSecondStepPageEndpoint(): string  {
        return this.pageEndpoint() + '/' + API_PAGES.ROUND_TRIP_SECOND_STEP;
    }

    static pageRoundTripFinalStepPageEndpoint(): string  {
        return this.pageEndpoint() + '/' + API_PAGES.ROUND_TRIP_FINAL_STEP;
    }

    // Auth
    static auth(): string {
        return this.getApiUrl() + 'auth/';
    }
    static authLogin(): string {
        return this.auth() + 'login';
    }

    static authSocialLogin(): string {
        return this.auth() + 'socialLogin/';
    }

    static authLogout(): string {
        return this.auth() + 'logout';
    }

    static authRefresh(): string {
        return this.auth() + 'refresh';
    }

    // Customer
    static customer(): string {
        return this.getApiUrl() + 'customer/';
    }

    static customerRegister(): string {
        return this.customer() + 'register';
    }

    static getCustomerData(): string {
        return this.customer() + 'get-customer';
    }

    static customerForgotPassword(): string {
        return this.customer() + 'forgot-password';
    }

    static customerChangePassword(): string {
        return this.customer() + 'change-password';
    }

    static customerActivate(): string {
        return this.customer() + 'activate';
    }

    static customerUpdate(): string {
        return this.customer()  + 'update';
    }

    static customerUpdatePassword(): string {
        return this.customer()  + 'update-password';
    }

    static customerSetSettings(): string {
        return this.customer()  + 'set-settings';
    }

    static customerGetSettings(): string {
        return this.customer()  + 'get-settings';
    }

    static customerGetBookings(): string {
        return this.customer()  + 'get-bookings';
    }

    static customerGetInvoices(): string {
        return this.customer()  + 'get-invoices';
    }

    static customerGetBooking(): string {
        return this.customer()  + 'get-booking/';
    }

    static customerGetQRCode(): string {
        return this.customer()  + 'qr-code';
    }

    private static getApiUrl(): string {
        return store.getters.apiUrl;
    }
}